import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '~/components/Loader';
import { Container as DefaultContainer } from '~/pages/common';
import Header from '~/compositions/Header';
import {
  PageContainer,
  FormContainer,
  TitleContainer,
  Title,
  BackIcon,
  Description,
  Container,
} from './commonStyles';
import ErrorMessage from '~/components/ErrorMessage';
import FormIndicacao from '~/components/forms/FormIndicacao';
import FormIndicacaoProdutos from '~/components/forms/FormIndicacaoProdutos';
import { setStep } from '~/store/modules/indicacao/actions';

export default function SuggestBusiness(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const step = useSelector(state => state.indicacao.step);
  const errorCode = useSelector(state => state.errors.code);
  const isLoading = useSelector(state => state.loading);

  const Form = step === 2 ? FormIndicacaoProdutos : FormIndicacao;

  function verifyRoute() {
    if (props.match.url === '/indique/perguntas') {
      dispatch(setStep(2));
    } else {
      dispatch(setStep(1));
    }
  }

  // eslint-disable-next-line react/destructuring-assignment
  useEffect(verifyRoute, [props.match]);

  return (
    <>
      <Container>
        <Header />
      </Container>
      <PageContainer>
        <DefaultContainer fullWidth>
          <Loader isLoading={isLoading}>
            {errorCode ? (
              <ErrorMessage status={errorCode} />
            ) : (
              <FormContainer data-testid="test-container">
                <TitleContainer>
                  <BackIcon
                    onClick={() => history.goBack()}
                    icon={['fas', 'chevron-left']}
                  />
                  <Title>Indique um estabelecimento</Title>
                </TitleContainer>
                <Description>
                  Insira os dados abaixo e indique um estabelecimento para fazer
                  parte da nossa rede credenciada. Não esqueça de selecionar
                  quais tipos de cartão você deseja utilizar e o tipo de
                  estabelecimento que está cadastrando.
                </Description>
                <Form {...props} />
              </FormContainer>
            )}
          </Loader>
        </DefaultContainer>
      </PageContainer>
    </>
  );
}

SuggestBusiness.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};
